import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api';

import AdminLayout from './Components/AdminLayout';
import CuisineModal from './Components/CuisinesModal';

export default function AdminCuisines()
{
    const [cuisines, setCuisines] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    const [selectedCuisine, setSelectedCuisine] =
        useState<any>(null);

    const loadCuisines = async () => {

        const response =
            await api.get(
                '/cuisines'
            );

        setCuisines(
            response.data
        );
    };

    useEffect(() => {

        loadCuisines();

    }, []);

    const handleSave = async (
        data: FormData
    ) => {

        if (
            selectedCuisine
        ) {

            await api.post(

                `/cuisines/${selectedCuisine.id}?_method=PUT`,

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

        } else {

            await api.post(

                '/cuisines',

                data,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );
        }

        setModalOpen(
            false
        );

        setSelectedCuisine(
            null
        );

        loadCuisines();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this cuisine?'
            )
        ) {
            return;
        }

        await api.delete(
            `/cuisines/${id}`
        );

        loadCuisines();
    };

    const moveCuisineUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...cuisines];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setCuisines(
            updated
        );

        await api.post(
            '/cuisines/reorder',
            {
                cuisines:
                    updated.map(
                        (
                            cuisine,
                            position
                        ) => ({
                            id:
                            cuisine.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadCuisines();
    };

    const moveCuisineDown = async (
        index: number
    ) => {

        if (
            index >=
            cuisines.length - 1
        ) {
            return;
        }

        const updated =
            [...cuisines];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setCuisines(
            updated
        );

        await api.post(
            '/cuisines/reorder',
            {
                cuisines:
                    updated.map(
                        (
                            cuisine,
                            position
                        ) => ({
                            id:
                            cuisine.id,

                            display_order:
                                position + 1,
                        })
                    ),
            }
        );

        loadCuisines();
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Cuisines
                </h1>

                <button
                    className="action-btn"
                    onClick={() => {

                        setSelectedCuisine(
                            null
                        );

                        setModalOpen(
                            true
                        );

                    }}
                >
                    Add Cuisine
                </button>

            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {cuisines.map(
                    (
                        cuisine,
                        index
                    ) => (

                        <tr
                            key={
                                cuisine.id
                            }
                        >

                            <td>
                                {
                                    cuisine.name
                                }
                            </td>

                            <td>
                                {
                                    cuisine.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveCuisineUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveCuisineDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedCuisine(
                                                cuisine
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                cuisine.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <CuisineModal

                    cuisine={
                        selectedCuisine
                    }

                    onClose={() =>
                        setModalOpen(
                            false
                        )
                    }

                    onSave={
                        handleSave
                    }

                />

            )}

        </AdminLayout>

    );
}
